export default __webpack_public_path__ + "static/media/pgmico(40).0001396e.png";